export default __webpack_public_path__ + "static/media/NugaLogo.a0eecb1d.png";